import { Stack } from '@mui/material';
import React, { PropsWithChildren } from 'react';

import { OnboardingPageHeading, OnboardingPagePaper } from '@/layout/OnboardingPage';

interface NewPasswordPageContentProps extends PropsWithChildren {
  headlineText: string;
}

export const NewPasswordPageContent: React.FC<NewPasswordPageContentProps> = ({ headlineText, children }) => {
  return (
    <>
      <OnboardingPageHeading headlineText={headlineText} />
      <OnboardingPagePaper>
        <Stack spacing={3}>{children}</Stack>
      </OnboardingPagePaper>
    </>
  );
};
